import styled from 'styled-components';

export const ConfirmOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 80;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(0, 0, 0, 0.7);
`;

export const ConfirmCard = styled.div`
  width: 100%;
  max-width: 384px;
  padding: 24px;
  border-radius: 12px;
  background: #161616;
  border: 1px solid #262626;

  .header {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 12px;

    .icon-wrap {
      width: 36px;
      height: 36px;
      border-radius: 8px;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      background: ${({ $danger }) => ($danger ? 'rgba(239, 68, 68, 0.1)' : 'rgba(3, 160, 141, 0.12)')};
      color: ${({ $danger }) => ($danger ? '#EF4444' : 'var(--primary)')};
    }

    h3 {
      margin: 0;
      font-size: 18px;
      font-weight: 600;
      color: var(--white);
    }
  }

  .message {
    margin-bottom: 24px;
    font-size: 14px;
    line-height: 20px;
    color: #a0a0a0;

    strong,
    span {
      color: var(--white);
      font-weight: 500;
    }
  }

  .actions {
    display: flex;
    justify-content: flex-end;
    gap: 8px;

    button {
      padding: 8px 16px;
      border: 0;
      border-radius: 8px;
      font-size: 14px;
      cursor: pointer;
      transition: opacity 0.15s ease, color 0.15s ease, background 0.15s ease;
    }

    .cancel {
      background: transparent;
      color: #a0a0a0;

      &:hover {
        color: var(--white);
      }
    }

    .confirm {
      font-weight: 500;
      color: var(--white);
      background: ${({ $danger }) => ($danger ? '#EF4444' : 'var(--primary)')};

      &:hover:not(:disabled) {
        opacity: 0.9;
      }

      &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }
    }
  }
`;
